import React from 'react';

function Upcomingbadges() {
  return (
    <div className='container justify-content-center
      pb-5 pt-5'>
      <div className='row'>
        <div className='col text-center'>
          <img src='./assets/safe.svg'
            alt='Scaled Agile Framework for Enterprise'
            className='safeLogo'/>
        </div>
        <div className='col text-center'>
          <img src='./assets/icagile_brand.svg'
            alt='Internatioal Consortium for Agile'
            className='icAgileLogo'/>
        </div>
        <div className='col text-center'>
          <img src='./assets/Scrum Alliance.svg'
            alt='Scrum Alliance'
            className='scrumAllianceLogo'/>
        </div>
        <div className='col text-center'>
          <img src='./assets/devops_institute.png'
            alt='DevOps Institute'
            className='devopsInstituteLogo'/>
        </div>
        <div className='col text-center'>
          <img src='./assets/logo-4.png'
            alt='Kanban University'
            className='kanbanUniveristyLogo'/>
        </div>
      </div>
    </div>
  );
}

export default Upcomingbadges;
